/* eslint-disable no-undef */
import ReactDOM from 'react-dom/client';
import AdsManager from './ads/ads.manager';
import TpxPlayer from './contents/TpxPlayer';
import * as AdsManagerEvent from './ads/events/ads.manager.events';
import * as POSITIONS from './ads/constants/positions';
import * as STATES from './core/states/player.states';
import * as PLAYER_EVENT from './core/events/player.content.ad.events';
import { logDebugging, logError } from './log/logger';
import midroll from './utils/midroll';

import {
  createAdAndContentDivs,
  getDivIdForAd,
  getDivIdForContent,
  showDiv,
} from './utils/create.ad.and.content.divs';
import loadTracker from './tracker/loadtracker';
import getConsentData from './ads/gdpr/getConsentData';
import checkDebug from './utils/checkDebug';
import PlayerEvent from './core/events/player.event';
import getGeoData from './utils/getGeoData';
import * as TEMPLATES from './config/templates';
import JsTagDisplay from './ads/jstag/display';
import AdUnit from './ads/jstag/adUnit';
import { hideOverlay, showOverlay } from './utils/overlayVisibility';
import { SIZES_16_9, SIZES_9_16 } from './ssp/sspParamsConstants';
import { isMobile } from './utils/browserUtils';
import YoutubePlayerManager from './core/players/youtube/YoutubePlayerManager';
import { updateTappxKeyConfig } from './ssp/tappxkeySelector';
import getEid from './utils/eid';

export default class TpxContentAndAd {
  constructor(config) {
    this.config = config;
    updateTappxKeyConfig(this.config);
    this.playingContent = '';
    this.tpxPlayerContentAdEvent = new PlayerEvent('onTpxPlayerContentAdEvent');
    const created = createAdAndContentDivs(this.config);
    if (!created) {
      logError('No se han podido crear los contenedores de publicidad y contenido');
    }
    this.config.targetAdId = getDivIdForAd(this.config.targetId);
    this.config.targetContentId = getDivIdForContent(this.config.targetId);
    this.config.volume = this.config.volume || 1;
    this.config.template = this.config.template || TEMPLATES.EDITORIAL_TEMPLATE;
    this.config.theme = this.config.theme || 'playon';
    this.config.timesMidroll = this.config.timesMidroll || [];
    checkDebug(this.config);
    getGeoData();
    // eslint-disable-next-line no-undef
    this.rootCreated = ReactDOM.createRoot(document.getElementById(this.config.targetAdId));
    showDiv(this.config.targetAdId, false);
  }

  async init() {
    await loadTracker();
    getEid();
    // setTimeout(() => {
    //   this.initAd(POSITIONS.PREROLL);
    // }, 500);

    this.initPlayer();
    getConsentData.getConsent(this.config.endpoint);
  }

  initAd(position) {
    midroll.setfrequency(this.config.timesMidroll);
    if (position === POSITIONS.PREROLL && this.config.numAdsPre) {
      if (!this.adsManagerPreroll) {
        this.adsManagerPreroll = this.initAdsManagerByPosition(this.adsManagerPreroll, position);
        // window.tpx_players.push(this.adsManagerPreroll);
      } else {
        this.adsManagerPreroll = this.initAdsManagerByPosition(this.adsManagerPreroll, position);
      }
    } else if (
      position === POSITIONS.MIDROLL &&
      Array.isArray(this.config.timesMidroll) &&
      this.config.timesMidroll.length > 0 &&
      this.config.numAdsMid
    ) {
      if (!this.adsManagerMidroll) {
        this.adsManagerMidroll = this.initAdsManagerByPosition(this.adsManagerMidroll, position);
        // window.tpx_players.push(this.adsManagerMidroll);
      } else {
        this.adsManagerMidroll = this.initAdsManagerByPosition(this.adsManagerMidroll, position);
      }
    }
  }

  initAdsManagerByPosition(adsManager, position) {
    if (!adsManager) {
      // eslint-disable-next-line no-param-reassign
      adsManager = new AdsManager(this.config, position, this.rootCreated);
      this.activateAdsManagerEvents(adsManager);
      adsManager.initController(this.config.autoplay);
    } else {
      adsManager.playAds();
    }
    return adsManager;
  }

  activateAdsManagerEvents(adsManagerByPosition) {
    adsManagerByPosition.getEvent().subscribe((sender, eventArgs) => {
      const [action, position] = eventArgs.message;
      switch (action) {
        case AdsManagerEvent.INIT_BLOCK:
          // Pausamos el vídeo
          logDebugging('[TpxContentAndAd] AdsManager INIT_BLOCK POSITION ', position);
          showDiv(this.config.targetAdId, true);
          if (position === POSITIONS.POSROLL) {
            // cuando es un video de youtube, debemos quitar el player de youtube antes de mostrar la publi de posroll
            // if (this.player.videoPlayer.playerFactory instanceof YoutubePlayerManager) {
            //   this.player.videoPlayer.remove();
            // }
          } else {
            this.player.videoPlayer.pause();
          }

          this.playingContent = 'AD';
          this.dispatchEvent([PLAYER_EVENT.AD_BLOCK_STARTED]);
          break;

        case AdsManagerEvent.BLOCK_COMPLETED:
          logDebugging('[TpxContentAndAd] AdsManager BLOCK_COMPLETED ', position);
          // reanudamos el vídeo.
          if (adsManagerByPosition.position === POSITIONS.POSROLL)
            this.player.togglePlaylistModal();
          else this.player.videoPlayer.resume();
          showDiv(this.config.targetAdId, false);
          this.playingContent = 'CONTENT';
          this.dispatchEvent([PLAYER_EVENT.AD_BLOCK_COMPLETED]);

          break;

        default:
          break;
      }
    });
  }

  async initOverlay() {
    const formatSizes = this.config.format === 'vertical' ? SIZES_9_16.OVERLAY : SIZES_16_9.OVERLAY;
    const adunit = new AdUnit(this.config)
      .setDivId('tpx-display-overlay')
      .setSizes(isMobile() ? formatSizes.MOBILE : formatSizes.DESKTOP)
      .build();
    if ((!adunit.tappxKey.mweb && !adunit.tappxKey.desktop) || !adunit.endpoint) {
      throw new AdException('AdUnit Params are empty', '201');
    }
    const jstagdisplay = new JsTagDisplay(this.itemContent);
    const resultDisplay = await jstagdisplay.call(adunit);
    if (!resultDisplay.error) {
      showOverlay(this.config);
    }
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      hideOverlay();
    }, 10000);
    logDebugging('overlay', resultDisplay);
  }

  async initPlayer() {
    this.player = new TpxPlayer(this.config);
    this.activatePlayerEvents();
    try {
      await this.player.loadPlayList();
      this.player.loadVideoPlayer();
      this.dispatchEvent([PLAYER_EVENT.PLAYER_LOADED]);
      // eslint-disable-next-line no-undef
      // window.tpx_players.push(this.player);
    } catch (error) {
      this.player.printError(error);
    }
  }

  activatePlayerEvents() {
    this.player.getEvent().subscribe(async (sender, eventArgs) => {
      // const [action] = eventArgs.message;
      const [eventState, playerState] = eventArgs.message;
      logDebugging('[TpxContentAndAd] player', eventState, playerState);
      switch (eventState) {
        case this.player.getEvent().STATE_EVENT:
          switch (playerState) {
            case STATES.LOADING:
              break;

            case STATES.STOPPED:
              // cuando es un video de youtube, debemos quitar el player de youtube antes de mostrar la publi de posroll
              if (this.player.videoPlayer.playerFactory instanceof YoutubePlayerManager) {
                this.player.videoPlayer.remove();
              }
              if (this.adsManagerPosroll?.adsController?.totalAdsByBlock > 0) {
                this.adsManagerPosroll.playAds();
              } else this.player.togglePlaylistModal();
              break;

            case STATES.PLAYING:
              if (!this.config.muted) this.handleUnmute();
              if (!this.config.autoplay) {
                this.config.autoplay = true;
              }
              if (!this.started) {
                this.dispatchEvent([PLAYER_EVENT.CONTENT_STARTED]);
                this.started = true;
              }
              break;

            case STATES.SKIPPED:
              this.player.loadNextVideoPlayer();
              break;

            case STATES.REPLAY:
              this.player.replay();
              break;

            default:
          }
          break;

        case this.player.getEvent().THROW_MIDROLL:
          // buscamos publi para midroll
          this.initAd(POSITIONS.MIDROLL);
          break;

        case this.player.getEvent().THROW_OVERLAY:
          // buscamos publi para OVERLAY
          this.initOverlay();
          break;

        case this.player.getEvent().THROW_POSROLL:
          // buscamos publi para midroll
          if (this.config.numAdsPos) {
            this.adsManagerPosroll = new AdsManager(
              this.config,
              POSITIONS.POSROLL,
              this.rootCreated,
            );
            // window.tpx_players.push(this.adsManagerPosroll);
            this.activateAdsManagerEvents(this.adsManagerPosroll);
            this.adsManagerPosroll.initController();
          }

          // this.initAd(POSITIONS.POSROLL);
          break;

        case AdsManagerEvent.BLOCK_COMPLETED:
          // reanudamos el vídeo.
          this.player.videoPlayer.resume();
          break;
        case this.player.getEvent().THROW_PREROLL:
          this.initAd(POSITIONS.PREROLL);
          break;

        case this.player.getEvent().INIT_PREROLL:
          if (this.adsManagerPreroll?.adsController?.totalAdsByBlock > 0) {
            setTimeout(() => {
              if (!this.isPlayingAd()) this.player.videoPlayer.resume();
            }, 3000);
            await this.adsManagerPreroll?.playAds();
          } else this.player.videoPlayer.resume();
          break;

        default:
          break;
      }
    });
  }

  resize() {
    this.player?.videoPlayer?.resize();
    this.adsManagerPreroll?.resize();
    this.adsManagerMidroll?.resize();
    this.adsManagerPosroll?.resize();
  }

  getEvent() {
    return this.tpxPlayerContentAdEvent;
  }

  play() {
    this.player?.videoPlayer?.play();
  }

  resume() {
    this.player?.videoPlayer?.resume();
  }

  isAOVPre() {
    return this.player?.config?.player?.AOVPre;
  }

  isAOVPos() {
    return this.player?.config?.player?.AOVPos;
  }

  isPlayerAd() {
    return this.player?.config?.player?.playerad;
  }

  isPlayingAd() {
    return this.playingContent === 'AD';
  }

  handleUnmute() {
    setTimeout(() => {
      this.player.videoPlayer.unmute();
    }, 500);
  }

  dispatchEvent(arg) {
    this.tpxPlayerContentAdEvent.fire(this, { message: arg });
  }
}
